import { withFormik } from 'formik';
import { inject } from 'mobx-react';
import { detailsSchema } from './components/detailsSchema';
import { DetailsOfficeworksForm } from './DetailsOfficeworksForm';
export var DetailsOfficeworks = inject('detailsStore', 'appStore')(withFormik({
    handleSubmit: function (values, bag) {
        bag.props.detailsStore.setDetailsFromForm(values);
        if (bag.props.detailsStore.emailChanged) {
            bag.props.detailsStore.checkExistingAccount(values.emailAddress);
        }
        else {
            bag.props.appStore.nextStep();
        }
    },
    mapPropsToValues: function (_a) {
        var detailsStore = _a.detailsStore;
        return detailsStore.details.formValues
            ? detailsStore.details.formValues
            : detailsStore.details.formInitialValues;
    },
    validationSchema: function () { return detailsSchema; },
})(DetailsOfficeworksForm));
//# sourceMappingURL=DetailsOfficeworks.js.map